import { createAction } from '@reduxjs/toolkit';

export const linkUpdateId = createAction('link/updateId');
export const linkUpdateUID = createAction('link/updateUID');
export const linkUpdateSID = createAction('link/updateSID');
export const linkUpdateIsAdded = createAction('link/updateIsAdded');
export const linkUpdateIsActive = createAction('link/updateIsActive');

export const linkStore = createAction('link/Store');
export const linkClear = createAction('link/clear');

export const linkUpdateLinks = createAction('link/updateLinks');

export const linkUpdateLinksRequest = createAction('link/updateLinksRequest');
export const linkUpdateLinksError = createAction('link/updateLinksError');
export const linkUpdateLinksStore = createAction('link/updateLinksStore');
export const linkUpdateNewLink = createAction('link/updateNewLink');

export const linkDeleteLinksRequest = createAction('link/deleteLinksRequest');
export const linkDeleteLinksError = createAction('link/deleteLinksError');
export const linkDeleteLinksStore = createAction('link/deleteLinksStore');

export const linkSortLinksRequest = createAction('link/sortLinksRequest');
export const linkSortLinksError = createAction('link/sortLinksError');
export const linkSortLinksStore = createAction('link/sortLinksStore');

export const linkUpdateDefaultBtnTextAlign = createAction('link/updateDefaultBtnTextAlign ');
export const linkUpdateDefaultBtnRightIcon = createAction('link/updateDefaultBtnRightIcon');
export const linkUpdateDefaultBtnIsGradient = createAction('link/updateDefaultBtnBackgroundType');
export const linkUpdateDefaultBtnGradientColor1 = createAction('link/updateDefaultBtnGradientColor1');
export const linkUpdateDefaultBtnGradientColor2 = createAction('link/updateDefaultBtnGradientColor2');
export const linkUpdateDefaultBtnGradientDirection = createAction('link/updateDefaultBtnGradientDirection');
export const linkUpdateDefaultBtnGradientOffset = createAction('link/updateDefaultBtnGradientOffset');

export const linkUpdateDefaultBtnBackgroundColor = createAction('link/updateButtonBackgroundColor ');
export const linkUpdateDefaultBtnTextColor = createAction('link/updateButtonTextColor');
export const linkUpdateDefaultBtnHeight = createAction('link/updateButtonHeight');
export const linkUpdateDefaultBtnOpacity = createAction('link/updateButtonOpacity');

export const linkUpdateButtonMode = createAction('link/updateButtonMode');
export const linkUpdateButtonTransparent = createAction('link/updateButtonTransparent');
export const linkUpdateIsButtonBorder = createAction('link/updateIsButtonBorder');
export const linkUpdateIsButtonRadius = createAction('link/updateIsButtonRadius');
export const linkUpdateButtonShape = createAction('link/updateIsButtonShape');
export const linkUpdateButtonShadow = createAction('link/updateIsButtonShadow');
export const linkUpdateButtonShadowColor = createAction('link/updateButtonShadowColor');
export const linkUpdateButtonBorder = createAction('link/updateButtonBorder');
export const linkUpdateButtonBorderColor = createAction('link/updateButtonBorderColor');

export const linkUpdateBgColor = createAction('link/updateBackgroundColor');
export const linkUpdateTextColor = createAction('link/updateTextColor');
export const linkUpdateOpacity = createAction('link/updateOpacity');
export const linkUpdateIsBackground = createAction('link/updateIsBackground');
export const linkUpdateIsFullWidth = createAction('link/updateIsFullWidth');
export const linkUpdatePadding = createAction('link/updatePadding');
export const linkUpdateMargin = createAction('link/updateMargin');
export const linkUpdateShadow = createAction('link/updateShadow');

export const linkUpdateTitle = createAction('link/updateTitle');
export const linkUpdateDescription = createAction('link/updateDescription');
export const linkUpdateTextAlign = createAction('link/updateTextAlign');
export const linkUpdateImage = createAction('link/updateImage');

export const linkUpdateButtonIsGradient = createAction('link/updateIsGradient');
export const linkUpdateButtonGradientColor1 = createAction('link/updateGradientColor1');
export const linkUpdateButtonGradientColor2 = createAction('link/updateGradientColor2');
export const linkUpdateButtonGradientDirection = createAction('link/updateGradientDirection');
export const linkUpdateButtonGradientOffset = createAction('link/updateGradientOffset');

export const linkUpdateSectionIsBackground = createAction('link/updateSectionIsBackground');
export const linkUpdateSectionTextColor = createAction('link/updateSectionTextColor');
export const linkUpdateSectionBackgroundColor = createAction('link/updateSectionBackgroundColor');
export const linkUpdateSectionOpacity = createAction('link/updateSectionOpacity');
export const linkUpdateSectionIsFullWidth = createAction('link/updateSectionIsFullWidth');
export const linkUpdateSectionShadow = createAction('link/updateSectionShadow');
export const linkUpdateSectionShadowColor = createAction('link/updateSectionShadowColor');
export const linkUpdateSectionPadding = createAction('link/updateSectionPadding');
export const linkUpdateSectionMargin = createAction('link/updateSectionMargin');
export const linkUpdateSectionBackgroundType = createAction('link/updateSectionBackgroundType');
export const linkUpdateSectionBackgroundImage = createAction('link/updateSectionBackgroundImage');
export const linkUpdateSectionGradientColor1 = createAction('link/updateSectionGradientColor1');
export const linkUpdateSectionGradientColor2 = createAction('link/updateSectionGradientColor2');
export const linkUpdateSectionGradientDirection = createAction('link/updateSectionGradientDirection');
export const linkUpdateSectionGradientOffset = createAction('link/updateSectionGradientOffset');
export const linkUpdateSectionBorder = createAction('link/updateSectionBorder');
export const linkUpdateSectionBorderColor = createAction('link/updateSectionBorderColor');
export const linkUpdateSectionShadowBorderColor = createAction('link/updateSectionShadowBorderColor');
export const linkUpdateSectionShape = createAction('link/updateSectionShape');

export const linkUpdateItemOpacity = createAction('link/updateItemOpacity');
export const linkUpdateItemShadow = createAction('link/updateItemShadow');
export const linkUpdateItemShadowColor = createAction('link/updateItemShadowColor');
export const linkUpdateItemBorder = createAction('link/updateItemBorder');
export const linkUpdateItemBorderColor = createAction('link/updateItemBorderColor');
export const linkUpdateItemShape = createAction('link/updateItemShape');
